import classNames from "classnames";
import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { InfoLight } from "assets/icons";
import { useLanguageContext } from "store/LanguageProvider";

export const ChatHeader = ({
  totalTime,
  timeLeft,
  children: SubmitChatButton,
  chatStarted,
  multiChatQuiz = false,
}) => {
  const { direction } = useLanguageContext()
  const fillPercent = (timeLeft / totalTime) * 100
  return (
    <>
      <div
        dir={direction}
        className={classNames(
          "min-h-[80px] sticky top-0 flex items-center justify-between py-2.5 px-[15px] border-b-[1px] border-b-stone-300",
          "sm:static sm:justify-between sm:bg-opacity-0 sm:bg-none sm:px-[30px] sm:shadow-none sm:flex",
          {
            "hidden": !chatStarted,
            "sm:py-[20px]": !multiChatQuiz
          }
        )}
      >
        <div className="flex items-center">
          <CircularTimer
            fillPercent={fillPercent}
            heightClassName="h-[50px]"
          />
          <p className="font-semibold text-base text-white sm:text-bistre ml-2 mr-2">
            {
              timeLeft === 0
                ? `0:00`
                : new Date(timeLeft * 1000).toISOString().substr(14, 5)
            }
          </p>
        </div>
        {SubmitChatButton}
      </div>
    </>
  );
};

export const MobileHeader = ({ 
  chatStarted, 
  endChatBtn, 
  openMobileInstructions, 
  totalTime, 
  timeLeft,
  toggleMobileDrawer,
  hasUnreadNotifications,
  multiChatQuiz = false
}) => {
  const fillPercent = (timeLeft / totalTime) * 100
  const { direction } = useLanguageContext()

  return (
    <div
      dir={direction}
      className={classNames(
        "min-h-[50px] text-white fixed w-full top-[0px] flex items-center py-2 px-[15px] z-[19] backdrop-blur-lg",
        "sm:hidden",
        {
          "hidden": !chatStarted,
          "justify-between": !multiChatQuiz,
          "justify-between px-[4px]": multiChatQuiz
        }
      )}
    >
      {/* Hamburger Menu for MultiChat */}
      {multiChatQuiz && (
        <div className="absolute flex items-center">
          <button onClick={toggleMobileDrawer} className="relative p-2">
            <div className="flex flex-col space-y-1">
              <span className="block w-5 h-0.5 bg-white"></span>
              <span className="block w-5 h-0.5 bg-white"></span>
              <span className="block w-5 h-0.5 bg-white"></span>
            </div>
            {hasUnreadNotifications && (
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full flex items-center justify-center">
                <span className="text-white text-xs font-bold">!</span>
              </div>
            )}
          </button>
        </div>
      )}

      {/* Timer - centered for MultiChat, left for regular Chat */}
      <div className={classNames("flex items-center", {
        "": !multiChatQuiz,
        "relative left-12": multiChatQuiz
      })}>
        <CircularTimer
          fillPercent={fillPercent}
          heightClassName="h-[30px]"
        />
        <p className="font-semibold text-base text-white sm:text-bistre ml-2 mr-2">
          {
            timeLeft === 0
              ? `0:00`
              : new Date(timeLeft * 1000).toISOString().substr(14, 5)
          }
        </p>
      </div>

      {/* Right side actions */}
      <div className={classNames("flex items-center", {
        "absolute right-4": multiChatQuiz
      })}>
        {endChatBtn}
        {openMobileInstructions && (
          <span onClick={openMobileInstructions} className="ml-2 p-1">
            <InfoLight />
          </span>
        )}
      </div>
    </div>
  )
}

const CircularTimer = ({ fillPercent, heightClassName = "" }) => {
  return (
    <span className="rounded-full max-w-[36px] sm:max-w-[unset] border-[#FFF] border-solid border-2 p-[2px]">
      <CircularProgressbar
        value={fillPercent}
        strokeWidth={50}
        styles={buildStyles({
          strokeLinecap: "butt",
          trailColor: '#fff',
          pathColor: "#AC95CF"
        })}
        className={`${heightClassName}`}
      />
    </span>
  )
}